// T042: Create date formatting utilities

/**
 * Formats a date as relative time (e.g., "2 hours ago")
 */
export function formatRelativeTime(date: Date): string {
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffSecs = Math.floor(diffMs / 1000)
  const diffMins = Math.floor(diffSecs / 60)
  const diffHours = Math.floor(diffMins / 60)
  const diffDays = Math.floor(diffHours / 24)

  if (diffSecs < 60) {
    return 'just now'
  } else if (diffMins < 60) {
    return `${diffMins}m ago`
  } else if (diffHours < 24) {
    return `${diffHours}h ago`
  } else if (diffDays < 7) {
    return `${diffDays}d ago`
  } else {
    return formatDate(date)
  }
}

/**
 * Formats a date as MMM DD, YYYY
 */
export function formatDate(date: Date): string {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date)
}

/**
 * Formats a number with K/M suffixes
 */
export function formatNumber(num: number): string {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}M`
  } else if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`
  }
  return num.toString()
}

/**
 * Formats reputation score (convert from raw to 0-100 scale)
 */
export function formatReputation(reputation: number): number {
  if (reputation === 0) return 25

  const neg = reputation < 0
  let reputationLevel = Math.log10(Math.abs(reputation))
  reputationLevel = Math.max(reputationLevel - 9, 0)
  reputationLevel *= neg ? -9 : 9
  reputationLevel += 25

  return Math.floor(reputationLevel)
}

/**
 * Formats payout amount
 */
export function formatPayout(amount: number): string {
  return `$${amount.toFixed(2)}`
}

/**
 * Truncates text with ellipsis
 */
export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}

/**
 * Formats RC percentage
 */
export function formatRC(percentage: number): string {
  return `${percentage.toFixed(1)}%`
}
